import React, { PropTypes } from 'react';
import { intlShape } from 'react-intl';
import classNames from 'classnames';

import './styles.scss';


const AverageRating = (props, context) => {
  const { rating, label, type, children, className } = props;

  let ratingQuality;
  const roundedRating = rating.toFixed(0);
  if (roundedRating >= 4) ratingQuality = 'good';
  else if (roundedRating >= 2) ratingQuality = 'ok';
  else ratingQuality = 'bad';

  const { formatNumber } = context.intl;

  return (
    <div className={classNames('average-rating', type, ratingQuality, className)}>

      { label ? `${label}:` : null }

      <span className='number'>
        { label ? ' ' : null }
        { formatNumber(rating, {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        }) }
      </span>

      { children }

    </div>
  );
};

AverageRating.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  label: PropTypes.string,
  rating: PropTypes.number.isRequired,
  type: PropTypes.string,
};

AverageRating.defaultProps = {
  children: null,
  className: null,
  label: null,
  type: 'star',
};

AverageRating.contextTypes = {
  intl: intlShape,
};

export default AverageRating;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/AverageRating/index.jsx